import React from 'react';
import content from '../data/content';

export default function Services() {
  return (
    <section className="section" id="services">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Was wir bieten</span>
          <h2 className="section-title">Unsere Leistungen</h2>
          <p className="section-subtitle">
            Erfahrene IT-Experten für Ihre Projekte — von Consulting über Testmanagement bis Programm Management.
          </p>
        </div>
        <div className="services-grid">
          {content.services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-card-image">
                <img src={service.image} alt={service.title} />
              </div>
              <div className="service-card-body">
                  <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
